import { render } from "./TableColumnForm.vue?vue&type=template&id=bb01aec4&scoped=true&ts=true"
import script from "./TableColumnForm.vue?vue&type=script&lang=ts"
export * from "./TableColumnForm.vue?vue&type=script&lang=ts"

import "./TableColumnForm.vue?vue&type=style&index=0&id=bb01aec4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb01aec4"]])

export default __exports__